export default __webpack_public_path__ + "static/media/prerequisites.0e230ca4.svg";